import React, { useState } from "react";
import OtpInput from "react-otp-input";
import ErrorControl from "./error_control.js";
import { ArrowBigLeft } from 'lucide-react';
import * as S from "./styles";

function OtpPrompt({ updateOtp, uuid, ip, showMsgErro, msgErro, timerOtp, resent, titulo, voltar, showVoltar }) {
  const [otp, setOtp] = useState("");
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return width;
}
let w = getWindowDimensions();

w =  Math.round(Math.min(Math.max(w/20,20),50));
  return (
    <S.BottomSheet>
      <S.DetailBox><S.LinhaCards>
        {!!showVoltar && <S.LinhaCardsItemp>
          <S.PrimaryButtonLittle onClick={voltar}><ArrowBigLeft /></S.PrimaryButtonLittle></S.LinhaCardsItemp>}
        
        <S.LinhaCardsItem><S.DestaquePlus>{titulo}</S.DestaquePlus></S.LinhaCardsItem></S.LinhaCards>
        <div style={{ alignContent: "center", justifyContent: "center", display: "flex" }}>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={4}
            inputStyle={{ fontSize: w, fontWeight: "bold", margin: 20 }}
            inputType="tel"
            renderSeparator={<span>-</span>}
            renderInput={(props) => <S.InputWrapper><input {...props} /></S.InputWrapper>}
          />
        </div>

        <ErrorControl show={showMsgErro} error={msgErro} />

        <S.PrimaryButton
          onClick={() => {
            updateOtp(otp);
          }}
          style={{
            fontSize: "28px",
            fontWeight: "bold",
          }}>
          Continuar
        </S.PrimaryButton>

        <S.PrimaryButton variant={timerOtp > 0 ? "disabled" : null} 
          onClick={() => {
            if (timerOtp === 0) {
              resent();
            }
          }}
          style={{
            fontSize: "28px",
            fontWeight: "bold",
          }}>
          Reenviar {timerOtp > 0 && timerOtp}
        </S.PrimaryButton>



      </S.DetailBox>
    </S.BottomSheet>
  );
}

export default OtpPrompt;
